import { STATIC_BASE_URL } from 'config';

const DefaultImg: React.FC = (props) => {
  return <img src={`${STATIC_BASE_URL}/images/icon-img.svg`} alt="" {...props} />;
};

export default DefaultImg;
